import { useTranslation } from "react-i18next";
import { OcRoleFilterSwitchItemProps } from "./role-filter-switch-item";

interface UseRoleFilterSwitchItemProps {
  label: OcRoleFilterSwitchItemProps["label"];
}

export const useOcRoleFilterSwitchItem = ({
  label,
}: UseRoleFilterSwitchItemProps) => {
  const { t } = useTranslation();
  const translatedLabel = t(label);

  return { translatedLabel };
};
